module.exports = __webpack_public_path__ + "static/media/vintage-shabby-chic.5a241742.png";